import { DataTable } from "@/components/data-table/data-table";
import { AdminUserTeamDTO } from "@shaarp/common";
import { dataTableAdminUserTeamsColumns } from "./data-table-admin-users-teams-columns";

export default function DataTableAdminUserTeams({
  teams,
  isLoading = false,
  emptyText = "Aucune équipe associée",
}: {
  teams: AdminUserTeamDTO[];
  isLoading?: boolean;
  emptyText?: string;
}) {
  return (
    <DataTable
      data={teams || []}
      columns={dataTableAdminUserTeamsColumns()}
      showFilter={false}
      pagination={false}
      showTotalCounter={false}
      isLoading={isLoading}
      emptyText={emptyText}
    />
  );
}
